import { PathStopAPI } from '../../../api/bussched/PathStopAPI';

export class PathStopsCommand {
    listStops(edition, line, successCallback, errorCallback) {
        const apiResult = PathStopAPI.listStops(edition, line);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Paragens da Linha selecionada");
            }
        });
    }

    listLines(edition, stop, successCallback, errorCallback) {
        const apiResult = PathStopAPI.listLines(edition, stop);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Linhas da Paragem selecionada");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/commands/PathStopsCommand.js